import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute, PublicRoute } from "./ProtectedRoute";
import { AuthLayout, DashboardLayout } from "../layouts";
import {
  LoginPage,
  RegisterPage,
  PasswordResetPage,
  SetPasswordPage,
} from "../../pages/auth";
import { LandingPage } from "../../pages/landing";
import { DashboardPage } from "../../pages/dashboard";
import { LoadsPage } from "../../pages/loads";
import { DocumentsPage } from "../../pages/documents";
import { DriversVehiclesPage } from "../../pages/driver-vehicles";
import { BillingPage } from "../../pages/billing";
import { FeedbackPage } from "../../pages/feedback";
import { AuditLogsPage } from "../../pages/audit-logs";
import { SystemSettingsPage } from "../../pages/settings";
import { ChangePasswordPage, ViewEditProfilePage } from "../../pages/profile";

export function AppRoutes() {
  return (
    <Routes>
      {/* Landing page - public */}
      <Route path="/" element={<LandingPage />} />

      {/* Auth routes */}
      <Route element={<PublicRoute />}>
        <Route path="/auth" element={<AuthLayout />}>
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="reset-password" element={<PasswordResetPage />} />
          <Route path="set-new-password" element={<SetPasswordPage />} />
        </Route>
      </Route>

      {/* Dashboard routes - moved under /app */}
      <Route element={<ProtectedRoute />}>
        <Route path="/app" element={<DashboardLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="loads" element={<LoadsPage />} />
          <Route path="documents" element={<DocumentsPage />} />
          <Route path="drivers-and-vehicles" element={<DriversVehiclesPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="feedback" element={<FeedbackPage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />
          <Route path="system-settings" element={<SystemSettingsPage />} />
          <Route path="profile" element={<ViewEditProfilePage />} />
          <Route path="profile/change-password" element={<ChangePasswordPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
